(() => {
  const finders = document.querySelectorAll('[data-ref-finder]');
  if (!finders.length) return;

  const productNames = {
    hydro: 'HYDRO+',
    cm5: 'CM5',
    whey: 'Whey Pro'
  };

  const priceByProduct = {
    hydro: 29959,
    cm5: 33959,
    whey: 129959
  };

  const formatPrice = (cents) => {
    const rands = Math.floor(cents / 100).toLocaleString('en-US');
    const decimal = String(cents % 100).padStart(2, '0');
    return `R${rands}<sup>.${decimal}</sup>`;
  };

  const joinNames = (ids) => {
    const names = ids.map((id) => productNames[id]);
    if (names.length < 2) return names[0] || '';
    return `${names.slice(0, -1).join(', ')} + ${names.at(-1)}`;
  };

  const resolveShopHref = (href) => {
    const isLocalPreview = window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost';
    return isLocalPreview ? new URL(href, 'https://59nutrition.com').href : href;
  };

  finders.forEach((finder) => {
    const screens = Array.from(finder.querySelectorAll('[data-finder-screen]'));
    const progress = finder.querySelector('[data-finder-progress]');
    const status = finder.querySelector('[data-finder-status]');
    const answers = {};

    const resultNodes = {
      profile: finder.querySelector('[data-result-profile]'),
      title: finder.querySelector('[data-result-title]'),
      summary: finder.querySelector('[data-result-summary]'),
      productName: finder.querySelector('[data-result-product-name]'),
      price: finder.querySelector('[data-result-price]'),
      priceLabel: finder.querySelector('[data-result-price-label]'),
      factLabels: [1, 2, 3].map((number) => finder.querySelector(`[data-result-fact-label-${number}]`)),
      facts: [1, 2, 3].map((number) => finder.querySelector(`[data-result-fact-${number}]`)),
      why: finder.querySelector('[data-result-why]'),
      before: finder.querySelector('[data-result-routine-before]'),
      during: finder.querySelector('[data-result-routine-during]'),
      after: finder.querySelector('[data-result-routine-after]'),
      showcase: finder.querySelector('[data-result-showcase]'),
      products: finder.querySelector('[data-result-products]'),
      primary: finder.querySelector('[data-result-primary]')
    };

    const scrollToFinder = () => {
      const top = finder.getBoundingClientRect().top + window.scrollY - 100;
      window.scrollTo({ top: Math.max(0, top), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    };

    const showScreen = (key, shouldScroll = true) => {
      const target = screens.find((screen) => screen.dataset.finderScreen === String(key));
      if (!target) return;

      screens.forEach((screen) => {
        screen.classList.remove('is-active');
        screen.hidden = screen !== target;
      });
      target.classList.remove('is-active');
      void target.offsetWidth;
      target.classList.add('is-active');
      finder.dataset.currentScreen = String(key);

      const step = Number(key);
      const percentage = key === 'result' ? 100 : Number.isFinite(step) ? step * 25 : 0;
      if (progress) progress.style.width = `${percentage}%`;
      if (status) {
        status.textContent = key === 'intro'
          ? 'Ready / Under 59 seconds'
          : key === 'result'
            ? 'Your 59 / Complete'
            : `Choice ${step} of 4`;
      }

      const heading = target.querySelector('h1, h2');
      if (heading && shouldScroll) {
        heading.setAttribute('tabindex', '-1');
        window.setTimeout(() => heading.focus({ preventScroll: true }), 80);
      }
      if (shouldScroll) window.setTimeout(scrollToFinder, 30);
    };

    const rankProducts = () => {
      const scores = { hydro: 0, cm5: 0, whey: 0 };
      const priority = { hydro: 0, cm5: 1, whey: 2 };

      if (answers.goal === 'hydration') scores.hydro += 5;
      if (answers.goal === 'strength') scores.cm5 += 5;
      if (answers.goal === 'recovery') scores.whey += 5;
      if (answers.goal === 'complete') Object.keys(scores).forEach((key) => { scores[key] += 2; });

      if (answers.moment === 'before') scores.hydro += 3;
      if (answers.moment === 'back-nine') scores.hydro += 4;
      if (answers.moment === 'training') scores.cm5 += 4;
      if (answers.moment === 'after') scores.whey += 4;

      if (answers.frequency === 'regular') {
        scores.hydro += 1;
        scores.cm5 += 1;
      }
      if (answers.frequency === 'intense') Object.keys(scores).forEach((key) => { scores[key] += 1; });

      return Object.keys(scores).sort((left, right) => scores[right] - scores[left] || priority[left] - priority[right]);
    };

    const hydrationValue = () => {
      if (answers.frequency === 'light') return 'At one active day per week, one 10-stick box covers roughly ten sessions.';
      if (answers.frequency === 'regular') return 'At two to three active days per week, one box covers roughly three to five weeks.';
      return 'At four or more active days per week, the 3-for-2 offer gives you 30 portable servings for R599.18.';
    };

    const pairRoutine = (selected) => {
      const key = [...selected].sort().join('-');
      if (key === 'cm5-hydro') {
        return {
          before: 'Take CM5 daily and pack one HYDRO+ stick.',
          during: 'Mix HYDRO+ into 500-750ml for the round or session.',
          after: 'Keep the same simple CM5 routine tomorrow.',
          why: `HYDRO+ supports the active moment while CM5 gives your training routine a consistent daily anchor. ${hydrationValue()}`
        };
      }
      if (key === 'hydro-whey') {
        return {
          before: 'Pack one HYDRO+ stick before you leave.',
          during: 'Mix HYDRO+ into 500-750ml around activity.',
          after: 'Use Whey Pro to support your daily protein intake.',
          why: `This pairing connects the full active window: practical hydration around the work and 25g protein per Whey Pro serving after it. ${hydrationValue()}`
        };
      }
      return {
        before: 'Make the 5g CM5 serving part of your daily routine.',
        during: 'Train or play with the work already planned.',
        after: 'Use Whey Pro to support daily protein intake and recovery.',
        why: 'CM5 supports a consistent daily creatine routine, while Whey Pro adds 25g protein per serving after training or long days on the course.'
      };
    };

    const singleResult = (product) => {
      if (product === 'hydro') {
        return {
          profile: 'Back-nine ready',
          title: 'Your hydration-first routine.',
          productName: productNames.hydro,
          summary: 'Your priority sits inside the active window, so the best first move is one portable product that is easy to keep in the bag.',
          price: formatPrice(priceByProduct.hydro),
          priceLabel: 'HYDRO+ / 10 Passionfruit sticks',
          factLabels: ['Sticks', 'Mix with', 'Sugar'],
          facts: ['10', '500-750ml', '<0.1g'],
          why: `HYDRO+ is built for the course, the gym, and long days on the move. ${hydrationValue()}`,
          before: 'Put one individually packed HYDRO+ stick in your bag.',
          during: 'Mix it into 500-750ml of water around activity.',
          after: 'Restock the bag so the next round starts ready.',
          href: '/products/59-hydro-plus-passionfruit',
          cta: 'View HYDRO+'
        };
      }
      if (product === 'cm5') {
        return {
          profile: 'Power builder',
          title: 'Your consistency-first routine.',
          productName: productNames.cm5,
          summary: 'Your answers point to repeatable training support, so the highest-value move is a simple daily habit rather than a complicated stack.',
          price: formatPrice(priceByProduct.cm5),
          priceLabel: 'CM5 / 60 unflavoured servings',
          factLabels: ['Servings', 'Daily serving', 'Per day'],
          facts: ['60', '5g', 'R5.66'],
          why: 'CM5 gives you sixty 5g servings in one tub, creating a straightforward daily creatine routine at roughly R5.66 per serving.',
          before: 'Take one 5g CM5 serving as part of your daily routine.',
          during: 'Keep training and playing without adding extra steps.',
          after: 'Repeat the same 5g routine tomorrow.',
          href: '/products/59-cm5-unflavoured',
          cta: 'View CM5'
        };
      }
      return {
        profile: 'Recovery first',
        title: 'Your protein-first routine.',
        productName: productNames.whey,
        summary: 'Your biggest opportunity comes after the work, where a reliable protein routine can make recovery easier to repeat.',
        price: formatPrice(priceByProduct.whey),
        priceLabel: 'Whey Pro / 1kg Chocolate Hazelnut',
        factLabels: ['Protein', 'Tub size', 'Tax'],
        facts: ['25g', '1kg', 'Included'],
        why: 'Whey Pro delivers 25g protein per serving in a smooth Chocolate Hazelnut formula for training days and long rounds.',
        before: 'Plan the session or round you are recovering from.',
        during: 'Finish the work with your post-activity plan ready.',
        after: 'Use Whey Pro to support your daily protein intake.',
        href: '/products/59-whey-pro-choc-hazelnut',
        cta: 'View Whey Pro'
      };
    };

    const buildResult = () => {
      const ranked = rankProducts();
      const selected = answers.scope === 'complete' ? ['hydro', 'cm5', 'whey'] : ranked.slice(0, answers.scope === 'pair' ? 2 : 1);
      let result;

      if (selected.length === 3) {
        result = {
          profile: 'Complete competitor',
          title: 'Your full-performance routine.',
          productName: '59 Stack',
          summary: 'You want one practical system across the full cycle: prepare for activity, support consistent training, and recover after the work.',
          price: 'R1,799<sup>.59</sup>',
          priceLabel: '59 Stack / Whey Pro + 2 HYDRO+ + CM5',
          factLabels: ['Saving', 'Delivery', 'Tax'],
          facts: ['R438.77', 'Free', 'Included'],
          why: 'The 59 Stack brings all three formulas together and adds a second HYDRO+ box for continuity. It saves R438.77 versus buying the products separately and qualifies for free shipping.',
          before: 'Take CM5 daily and put one HYDRO+ stick in the bag.',
          during: 'Mix HYDRO+ into 500-750ml around the round or session.',
          after: 'Use Whey Pro to support daily protein intake and recovery.',
          href: '/collections/all#member-bundle',
          cta: 'View the 59 Stack'
        };
      } else if (selected.length === 2) {
        const pair = pairRoutine(selected);
        const total = selected.reduce((sum, product) => sum + priceByProduct[product], 0);
        const pairKey = [...selected].sort().join('-');
        const profileByPair = {
          'cm5-hydro': 'Round-ready builder',
          'hydro-whey': 'End-to-end player',
          'cm5-whey': 'Train and recover'
        };
        result = {
          profile: profileByPair[pairKey],
          title: 'Your two-moment routine.',
          productName: joinNames(selected),
          summary: `${joinNames(selected)} covers the two moments your answers made most important, without turning your setup into a complicated programme.`,
          price: formatPrice(total),
          priceLabel: `${joinNames(selected)} / Combined`,
          factLabels: ['Products', 'Delivery', 'Tax'],
          facts: ['2', total >= 150000 ? 'Free' : 'R59', 'Included'],
          why: pair.why,
          before: pair.before,
          during: pair.during,
          after: pair.after,
          href: '/collections/all',
          cta: 'Shop recommended products'
        };
      } else {
        result = singleResult(selected[0]);
      }

      resultNodes.profile.textContent = result.profile;
      resultNodes.title.textContent = result.title;
      resultNodes.summary.textContent = result.summary;
      resultNodes.productName.textContent = result.productName;
      resultNodes.price.innerHTML = result.price;
      resultNodes.priceLabel.textContent = result.priceLabel;
      resultNodes.why.textContent = result.why;
      resultNodes.before.textContent = result.before;
      resultNodes.during.textContent = result.during;
      resultNodes.after.textContent = result.after;
      resultNodes.primary.href = resolveShopHref(result.href);
      resultNodes.primary.querySelector('span:first-child').textContent = result.cta;

      result.factLabels.forEach((label, index) => { resultNodes.factLabels[index].textContent = label; });
      result.facts.forEach((fact, index) => { resultNodes.facts[index].textContent = fact; });

      const productCards = Array.from(resultNodes.products.querySelectorAll('[data-result-product]'));
      productCards.forEach((card) => { card.hidden = !selected.includes(card.dataset.resultProduct); });
      resultNodes.products.dataset.productCount = String(selected.length);

      const showcaseProducts = Array.from(resultNodes.showcase.querySelectorAll('[data-result-hero-product]'));
      showcaseProducts.forEach((product) => { product.hidden = !selected.includes(product.dataset.resultHeroProduct); });
      resultNodes.showcase.dataset.productCount = String(selected.length);
    };

    finder.querySelector('[data-finder-start]')?.addEventListener('click', () => showScreen('1'));

    finder.querySelectorAll('[data-finder-answer]').forEach((button) => {
      button.setAttribute('aria-pressed', 'false');
      button.addEventListener('click', () => {
        const key = button.dataset.finderAnswer;
        const value = button.dataset.value;
        answers[key] = value;
        finder.querySelectorAll(`[data-finder-answer="${key}"]`).forEach((option) => {
          const isSelected = option === button;
          option.classList.toggle('is-selected', isSelected);
          option.setAttribute('aria-pressed', String(isSelected));
        });

        const current = Number(finder.dataset.currentScreen);
        if (key === 'scope' || current === 4) {
          buildResult();
          showScreen('result');
        } else {
          showScreen(String(current + 1));
        }
      });
    });

    finder.querySelectorAll('[data-finder-back]').forEach((button) => {
      button.addEventListener('click', () => showScreen(button.dataset.finderBack));
    });

    finder.querySelector('[data-finder-restart]')?.addEventListener('click', () => {
      Object.keys(answers).forEach((key) => delete answers[key]);
      finder.querySelectorAll('[data-finder-answer]').forEach((button) => {
        button.classList.remove('is-selected');
        button.setAttribute('aria-pressed', 'false');
      });
      showScreen('intro');
    });

    showScreen('intro', false);
  });
})();
